import { useContext } from 'react'

import { priorityBadgeType, priorityLabel } from '@/common/app/modules/media/articleCreator'
import { actionTypeLabel } from '@/common/app/modules/media/mediaAction'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import InsideArea, { BgColor } from '@/components/view/layouts/area/InsideArea'
import Modal, { ModalType } from '@/components/view/layouts/modal/Modal'
import ModalContent from '@/components/view/layouts/modal/ModalContent'
import ModalFooter from '@/components/view/molecules/modal/ModalFooter'
import ModalHeader from '@/components/view/molecules/modal/ModalHeader'

import { DecomposeResultModalContext } from '@/components/container/modal/automationReview/DecomposeResultModalProvider'

// 戦略アクションのAI分解結果モーダル
const DecomposeResultModal = () => {
  const { modal, showing, hide } = useContext(DecomposeResultModalContext)
  const result = modal.result
  const decomposed = result?.decomposed ?? []

  return (
    <Modal show={showing} type={ModalType.MIDDLE}>
      <ModalHeader
        text={`AI分解結果 ${result?.ok ? '（成功）' : '（失敗）'}`}
        onClickClose={hide}
      />
      <ModalContent>
        {result && (
          <div className='flex flex-col gap-4'>
            {result.decompose_summary && (
              <InsideArea color={BgColor.INFO} border>
                <Text size={12} lineHeight={150}>
                  <strong>要約:</strong> {result.decompose_summary}
                </Text>
              </InsideArea>
            )}
            {result.error && (
              <Text size={12} color={TextColor.CRITICAL}>
                エラー: {result.error}
              </Text>
            )}
            {decomposed.length > 0 ? (
              <div className='flex flex-col gap-2'>
                <Text size={12} color={TextColor.SECONDARY}>
                  提案中タブに以下の {decomposed.length}{' '}
                  件が追加されました（各カードで実施日を設定してください）:
                </Text>
                {decomposed.map((c) => (
                  <InsideArea key={c.id} color={BgColor.SECONDARY} border>
                    <div className='flex flex-col gap-1'>
                      <div className='flex flex-wrap items-center gap-1.5'>
                        <Badge size={10} badgeType={BadgeType.EMPHASIS}>
                          {actionTypeLabel(c.action_type)}
                        </Badge>
                        <Badge size={10} badgeType={priorityBadgeType(c.priority)}>
                          {priorityLabel(c.priority)}
                        </Badge>
                        <Text size={10} color={TextColor.SECONDARY}>
                          #{c.id}
                        </Text>
                      </div>
                      <Text size={12} weight='bold'>
                        {c.title}
                      </Text>
                      {(c.target_keywords ?? []).length > 0 && (
                        <div className='flex flex-wrap gap-1'>
                          {c.target_keywords?.map((kw, i) => (
                            <Badge key={i} size={10} badgeType={BadgeType.SECONDARY}>
                              {kw}
                            </Badge>
                          ))}
                        </div>
                      )}
                    </div>
                  </InsideArea>
                ))}
              </div>
            ) : (
              <Text size={12} color={TextColor.SECONDARY} align='center'>
                子アクションが生成されませんでした
              </Text>
            )}
            {typeof result.next_step === 'string' && result.next_step && (
              <Text size={12} color={TextColor.SUCCESS}>
                次のステップ: {result.next_step}
              </Text>
            )}
          </div>
        )}
      </ModalContent>
      <ModalFooter>
        <Button color={ButtonColor.SECONDARY} size='large' onClick={hide}>
          閉じる
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default DecomposeResultModal
